module.exports = __webpack_public_path__ + "lv.d49ec9c69612028abc54.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/lv.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/lv.svg
// module chunks = styles